import _ from 'lodash';

import c from 'common/constants/flux-events';
import { serializeForApi } from 'services/resources/ad-preset';
import { browserHistory } from 'react-router';

import AdPresetActions from 'states/resources/ad-presets/actions';
import DoohPublishersActions from 'states/resources/doohPublishers/actions';

// -----------------
// New Ad Preset Form
// -----------------
export const newAdPresetForm = {
    init() {
        return async (dispatch, getState) => {
            const orgId = _.get(getState(), 'profile.organizationId');
            await dispatch(AdPresetActions.getAll(orgId));
            await dispatch(DoohPublishersActions.getAll());
        };
    },
    open() {
        return dispatch => {
            dispatch({
                type: c.NEW_AD_PRESET__DRAFT__OPEN,
                payload: {},
            });
            dispatch({
                type: c.NEW_AD_PRESET__DRAFT__INIT,
            });
        };
    },

    updateDraft(formData) {
        return {
            type: c.NEW_AD_PRESET__DRAFT__UPDATE,
            payload: { formData },
        };
    },

    showErrors() {
        return {
            type: c.NEW_AD_PRESET__DRAFT__SHOW_ERRORS,
            payload: {},
        };
    },

    submitDraft(formData, query) {
        return async (dispatch, getState) => {
            const sessionNewAdPresetForm = _.get(getState(), `adPresetNew`, undefined);
            if (!sessionNewAdPresetForm) {
                throw new Error('Store error: adPresetNew does not exist');
            }

            const errors = _.get(sessionNewAdPresetForm, 'errors', []);
            if (errors.length !== 0) {
                // There are errors don't do ajax
                dispatch({
                    type: c.NEW_AD_PRESET__DRAFT__SHOW_ERRORS,
                    payload: {},
                });
                return;
            }
            //
            // // No errors, essemble payload and serialize
            const draft = _.get(sessionNewAdPresetForm, `draft`, {});
            const payload_beforeSerialized = { ...draft };
            const payloadSerialized = serializeForApi(payload_beforeSerialized, []);

            dispatch({
                type: c.NEW_AD_PRESET__DRAFT__SUBMIT,
            });

            const orgId = _.get(getState(), `profile.ownOrganization.id`, undefined);

            await dispatch(AdPresetActions.create(orgId, payloadSerialized)).then(
                response => {
                    const adpreset = response;

                    dispatch({
                        type: c.NEW_AD_PRESET__DRAFT__SUBMIT_SUCCESS,
                        payload: { adpreset },
                    });

                    const campaignId = _.get(query, 'campaign');

                    browserHistory.push(
                        campaignId ? `/campaigns/${campaignId}/setup` : `/ad-preset`
                    );
                    // Tear down
                    dispatch({
                        type: c.NEW_AD_PRESET__DRAFT__CLOSE,
                    });
                },
                error => {
                    // throw toaster error for server errors

                    dispatch({
                        type: c.NEW_AD_PRESET__DRAFT__SUBMIT_FAIL,
                        error: error.body,
                    });
                }
            );
            await dispatch(AdPresetActions.getAll(orgId));
        };
    },

    cancelDraft(query) {
        const campaignId = _.get(query, 'campaign');
        browserHistory.push(campaignId ? `/campaigns/${campaignId}/setup` : `/ad-preset`);

        return {
            type: c.NEW_AD_PRESET__DRAFT__CLOSE,
        };
    },
};
